export default __webpack_public_path__ + "static/media/image 14.f2217e05.png";